import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=2f7a9068&scoped=true"
import script from "./MessageAlert.vue?vue&type=script&lang=js"
export * from "./MessageAlert.vue?vue&type=script&lang=js"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=2f7a9068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a9068",
  null
  
)

export default component.exports